module.exports = __webpack_public_path__ + "img/n3_.790ae332.png";